import React, { useContext, useEffect, useState } from 'react';
import { SwipeableViewsContext, PayRatesContext } from '../PayRates';
import RedirectToLogin from '../../../utils/RedirectToLogin';
import { getCurrentUser } from '../../../services/authService';
import { getPositionByDepartment } from '../../../services/positionsService';
import RaisePayRateFilters from './RaisePayRateUtils/RaisePayRateFilters';
import RaisePayRateList from './RaisePayRateUtils/RaisePayRateList';
import './RaisePayRate.scss';

function RaisePayRate() {
  const payRatesContext = useContext(PayRatesContext);
  const swipeableViewsContext = useContext(SwipeableViewsContext);
  const [departmentIdSelected, setDepartmentIdSelected] = useState(null);
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    swipeableViewsContext.updateSwipeableHeight();
  });

  useEffect(() => {
    const getDepartmentPositions = async () => {
      const { data } = await getPositionByDepartment(departmentIdSelected);
      setPositions(data.positions);
    }
    departmentIdSelected && getDepartmentPositions();
  }, [departmentIdSelected]);

  return (
    !getCurrentUser()
      ? <RedirectToLogin location={payRatesContext.props.location} />
      : <section className="RaisePayRate content-wrapper container-fluid">
          <RaisePayRateFilters setDepartmentIdSelected={setDepartmentIdSelected} />
          <RaisePayRateList positions={positions} />
        </section>
  )
}

export default RaisePayRate
